<template>
  <div class="order-code-column">
    <template v-if="orderInfoList.length === 0">
      <span>-</span>
    </template>
    <template v-else>
      <span
        v-for="(order, index) in orderInfoList"
        :key="order.id"
      >
        <BaseElButton
          type="text"
          class="underline p-0"
          @click="goToOrderDetail(order)"
        >
          {{ order.code }}
        </BaseElButton>
        <span v-if="index < orderInfoList.length - 1">、</span>
      </span>
    </template>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { useRouter } from 'vue-router/composables'
import { get } from 'lodash'

export default defineComponent({
  name: 'OrderCodeColumn',
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  setup (props) {
    const router = useRouter()

    /**
     * 取得所有訂單資訊列表
     * @returns {Array<{ type: string, id: string, code: string }>}
     */
    const orderInfoList = computed(() => {
      // 合約密碼（後台建立）無訂單編號
      if (props.row.createSource === 'admin') return []

      const relations = props.row.MiezoPasswordMemberRelations || []
      return relations
        .map((relation) => {
          const orderType = get(relation, 'bobOrderType')
          const orderId = get(relation, 'bobOrderId')
          const orderCode = get(relation, 'bobOrderCode')
          if (!orderType || !orderId || !orderCode) return null
          return { type: orderType, id: orderId, code: orderCode }
        })
        .filter(Boolean)
    })

    /**
     * 跳轉至訂單列表頁並開啟側邊欄
     * @param {{ type: string, id: string, code: string }} order
     */
    const goToOrderDetail = (order) => {
      const routeMap = {
        appointment: { name: 'ReservationList', query: { code: order.code } },
        course: { name: 'CourseOrderList', query: { code: order.code } },
        visitorAppointment: { name: 'PubAptReservationList' },
      }

      const route = routeMap[order.type]
      if (route) {
        router.push(route)
      }
    }

    return {
      orderInfoList,
      goToOrderDetail,
    }
  },
})
</script>

<style lang="postcss" scoped>
.order-code-column {
  @apply flex flex-wrap items-center justify-center gap-x-0;
}
</style>
